import { UnviewedIndicatorText } from "@/components/ui/unviewed-indicator-text";
import type { Screening } from "@/types/screeners";
import type { PropsWithTableInfo } from "@/types/third-party";

export const UnviewedIndicatorTextCell = ({
  info,
}: PropsWithTableInfo<Screening, string>) => {
  return (
    <UnviewedIndicatorText
      indicatorText="NEW"
      primaryText={info.getValue()}
      showIndicatorText={!info.row.original.viewedAt}
    />
  );
};
